// extracted by mini-css-extract-plugin
export default {"accordion":"AccordionWrapper_accordion__IO+Kt"};